var _style, _g, _path, _path2, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colorstar_id",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.colorstar_id .st0{fill:#FFCA55;}\n\t.colorstar_id .st1{opacity:0.2;fill:#FFFFFF;}\n\t.colorstar_id .st2{fill:url(#SVGID_1_);}\n\t.colorstar_id .st3{fill:url(#SVGID_2_);}\n\t.colorstar_id .st4{fill:#662D91;}\n\t.colorstar_id .st5{fill:#CCCCCC;}\n\t.colorstar_id .st6{fill:#666666;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7,89.9c-1.2,0.3-2.3,0.1-3.5-0.4c-2.1-0.9-3.3-2.6-3.4-4.8c-0.6-9.5-1-17.2-1.4-24.3 c0-0.3-0.1-0.4-0.3-0.5c-6.9-4.1-13.7-8.1-20.3-12.2c-0.8-0.5-1.4-1-2-1.5C1.4,46,1.2,45.8,1,45.7l-0.1-0.1l-0.1-0.1 C-0.2,44,0,42.5,0,42.3c0.3-2.5,1.7-4.2,4-5.1c1.1-0.4,2.3-0.9,3.4-1.3c0.5-0.2,1-0.4,1.5-0.6c1.4-0.5,2.8-1.1,4.2-1.6 c4.3-1.7,8.8-3.4,13.3-5c0.5-0.2,0.7-0.4,0.8-1c2-8.7,3.8-16,5.5-22.7c0.3-1.2,0.9-2.4,1.7-3.2c0.8-0.8,1.7-1.3,2.7-1.6 c2.1-0.5,4.3,0.4,5.9,2.2l0.8,1c4.7,5.6,9.5,11.4,14.2,17.2c0.5,0.6,0.9,0.7,1.7,0.7c3.3-0.3,6.8-0.6,10-0.8 c4.2-0.3,8.6-0.7,12.9-1.1c3.1-0.3,5.2,0.6,6.6,2.9l0,0.1l0,0.1c0.1,0.3,0.7,1.7,0.6,2.8c-0.1,1.7-1,3-1.8,4.2 c-0.2,0.3-0.4,0.5-0.6,0.8c-2,3-4,6.1-5.9,9.1c-2,3.1-4.1,6.2-6.1,9.3c0,0.1-0.1,0.2-0.1,0.3c0.5,1.2,1,2.3,1.4,3.4 c0.2,0.5,0.4,1,0.6,1.4c0.7,1.5,1.3,3.1,2,4.6c1.8,4.3,3.7,8.8,5.6,13.2c0.9,2.2,0.4,4.3-1.3,6.1c-0.8,0.8-1.6,1.2-2.6,1.5 c-1,0.2-2.1,0.2-3.4-0.1c-2.6-0.7-5.3-1.4-7.9-2c-5-1.3-10.2-2.6-15.4-4c-0.2,0-0.3-0.1-0.4,0c0,0-0.1,0-0.3,0.2 c-3.7,3.2-7.5,6.4-11.2,9.5c-1,0.8-1.9,1.6-2.9,2.4c-0.4,0.4-0.9,0.8-1.3,1.1c-1.1,0.9-2.2,1.9-3.4,2.8 C34.3,89.3,33.5,89.7,32.7,89.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.3,1c-0.8,0.2-1.5,0.6-2.2,1.3c-0.7,0.7-1.2,1.8-1.5,2.8c-1.9,7.6-3.7,15.1-5.5,22.7 c-0.2,0.9-0.6,1.3-1.4,1.6c-5.8,2.2-11.7,4.4-17.5,6.7C7.7,36.7,6,37.3,4.4,38c-2,0.8-3.2,2.3-3.4,4.4c0,0-0.2,1.3,0.6,2.6 c0.8,0.6,1.6,1.4,2.6,2c6.8,4.1,13.5,8.1,20.3,12.2c0.5,0.3,0.7,0.6,0.7,1.2c0.5,8.1,0.9,16.2,1.4,24.3c0.1,1.9,1.1,3.2,2.9,4 c1.8,0.8,3.5,0.5,4.9-0.7c1.6-1.3,3.1-2.6,4.7-3.9c4.7-4,9.4-7.9,14.1-11.9c0.2-0.2,0.4-0.3,0.7-0.4L37.3,1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4873,
    y1: 30.4059,
    x2: 47.4873,
    y2: 65.8675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.9,48.1c0,16.8,16.1,17.7,19.8,17.7c0.5,0,1,0,1.5,0c3.7,0,19.8-1,19.8-17.7c0-17-16.5-17.8-20-17.7 c-0.4,0-0.8,0-1.2,0C43.4,30.4,26.9,31.2,26.9,48.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4867,
    y1: 32.2597,
    x2: 47.4867,
    y2: 56.076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.2,48.1c0,3.1-0.6,5.7-1.8,7.9c-1.3-2.4-3.2-4.2-5.8-5.6c-4.1-2.1-8.7-2.4-10.4-2.4h-0.1 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0h-0.1c-1.8,0-6.3,0.2-10.4,2.4c-2.6,1.3-4.5,3.2-5.8,5.6c-1.2-2.2-1.8-4.9-1.8-7.9 c0-6.4,2.5-10.9,7.5-13.5c4.1-2.1,8.7-2.4,10.4-2.4h0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0h0.1c1.8,0,6.3,0.2,10.4,2.4 C63.7,37.2,66.2,41.8,66.2,48.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.6,36.1V24.4c1.2-0.4,2.1-1.6,1.8-3c-0.2-1-1-1.9-2.1-2.1c-1.7-0.3-3.1,1-3.1,2.5c0,1.2,0.8,2.2,1.9,2.5 V36c-1.9-2.5-4.2-4.2-6.4-5.4c-5-2.6-10.4-2.9-12.5-2.9h-0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0h-0.1 c-2.1,0-7.5,0.3-12.5,2.9c-2.1,1.1-4.4,2.7-6.3,5.2V24.4c1.2-0.4,2.1-1.6,1.8-3c-0.2-1-1-1.9-2.1-2.1c-1.7-0.3-3.1,1-3.1,2.5 c0,1.2,0.8,2.2,1.9,2.5v11.7h0c-2.8,0-5.1,2.2-5.1,5v3.3c0,1,0.4,1.9,1.1,2.6c0.5,0.5,1.1,0.8,1.8,1c0.3,0.1,0.6,0.1,0.8,0.1h0.7 v0c0-9.4,5-14,9.1-16.1c4.7-2.4,9.8-2.7,11.8-2.7h0.1c0.4,0,0.8,0,1.2,0h0.1c2,0,7.1,0.3,11.8,2.7c4.2,2.2,9.1,6.7,9.1,16.1v0H70 c0.3,0,0.5,0,0.8-0.1c0.7-0.1,1.4-0.5,1.9-1c0.7-0.7,1.1-1.6,1.1-2.6v-3.3C73.7,38.4,71.5,36.1,68.6,36.1L68.6,36.1z M26,21.9 c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1S26,22.5,26,21.9z M66.8,21.9c0-0.6,0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1C67.3,23,66.8,22.5,66.8,21.9z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M56.5,56.7H38.6c-4.9,0-9-4-9-9v-0.2c0-4.9,4-9,9-9h17.9c4.9,0,9,4,9,9v0.2C65.4,52.7,61.4,56.7,56.5,56.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.5,52c-0.6,0-1.1-0.1-1.6-0.3c-0.4-0.1-0.5-0.5-0.4-0.9c0.1-0.4,0.5-0.5,0.9-0.4c0.8,0.3,1.6,0.3,2.4,0 c0.4-0.1,0.7,0.1,0.9,0.4c0.1,0.4-0.1,0.7-0.4,0.9C48.7,51.9,48.1,52,47.5,52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 39.5,
    cy: 46.9,
    rx: 2.4,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 55.6,
    cy: 46.9,
    rx: 2.4,
    ry: 2.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorStar);
export default __webpack_public_path__ + "static/media/color_star.13652b780481ee812c26035dc5351b2b.svg";
export { ForwardRef as ReactComponent };